import FeedbackForm from "../../features/feedbackForm/FeedbackForm";
import PopUpLayout from "../../layouts/PopUpLayout"


const Feedback = () => {


    return (
        <PopUpLayout>
            <div className="pop-up-layout">
                <div className="main-pop-up">
                    <div className="content-wrap">
                        <div className="content">
                            <div className="main-page">
                                <FeedbackForm />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PopUpLayout>

    );
}

export default Feedback;